import {useMemo} from "react";

import {useQuery} from "@tanstack/react-query";
import {useSearchParams} from "react-router-dom";

import {DataGroupedByDate, groupByDate} from "@globals/functions/groupByDate";
import {ObjectWithAnyProps} from "@globals/types/utilityTypes";

import {getUpcomingOrders} from "./DailyOrdersService";
import {OrderResponseData, UPCOMING_ORDERS} from "./interfaces";

export type UpcomingOrdersResource = {
  isLoading: boolean;
  ordersGroupedByDate?: DataGroupedByDate<OrderResponseData>;
};

export default function useUpcomingOrders(
  dateFormat = "YYYY-MM-DD"
): UpcomingOrdersResource {
  const [searchParams, _] = useSearchParams();
  const getExtras = ["true", "1"].includes(
    searchParams.get("get_extras") ?? ""
  );
  const {isPending, data} = useQuery<OrderResponseData[]>({
    queryKey: [UPCOMING_ORDERS, getExtras],
    queryFn: () => getUpcomingOrders({get_extras: getExtras}),
    gcTime: 0,
  });

  const ordersGroupedByDate = useMemo(() => {
    if (data?.length) {
      return groupByDate<OrderResponseData>(data, "delivery_date", dateFormat);
    }
  }, [data]);

  return {
    isLoading: isPending,
    ordersGroupedByDate,
  };
}
